import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartBars16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconChartBars16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.5 12a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 1 0v9a.5.5 0 0 1-.5.5M3 11.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0zM2.5 13a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1zM7 11.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0zm-1.5.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.5.5m3.5-.5a.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartBars16);
